<template>
    <!-- Chat input area -->
    <div class="border-t border-gray-200 dark:border-gray-700 px-4 py-2 bg-white dark:bg-gray-900">
        <div class="flex items-start gap-2">
            <!-- Emoji Picker Trigger -->
            <button
                @click="showEmojiPicker = !showEmojiPicker"
                type="button"
                class="text-xl px-2 py-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700"
            >
                😊
            </button>
            <!-- Auto-Resizing Textarea -->
            <!-- Textarea (expands up) -->
            <div class="relative flex-1">
                <textarea
                    ref="textarea"
                    v-model="newMessage"
                    :disabled="disabled"
                    @input="autoResize"
                    @keydown.enter.exact.prevent="sendMessage"
                    @keydown.enter.shift.exact
                    rows="1"
                    placeholder="Type a message... (Enter to send)"
                    class="w-full resize-none overflow-y-auto max-h-[8rem] text-sm text-gray-800 dark:text-white bg-gray-100 dark:bg-gray-800 rounded-xl border border-gray-300 dark:border-gray-600 focus:ring-2 focus:ring-blue-400 focus:outline-none p-2.5 leading-5"
                ></textarea>
                <!-- Emoji Picker -->
                <div
                    v-if="showEmojiPicker"
                    class="absolute bottom-full mb-2 z-50 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 shadow-md rounded-md p-2 max-w-sm max-h-60 overflow-y-auto"
                >
                    <div class="grid grid-cols-8 gap-1 text-xl">
                        <span
                            v-for="emoji in emojis"
                            :key="emoji"
                            @click="appendEmoji(emoji)"
                            class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-1 rounded"
                            >{{ emoji }}</span
                        >
                    </div>
                </div>
            </div>

            <!-- Send Button aligned at top -->
            <t-button
                v-if="newMessage.trim().length"
                :disabled="disabled"
                @click="sendMessage"
                class="h-10 mt-0 px-4 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-xl shadow-md"
            >
                Send
            </t-button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                newMessage: '',
                showEmojiPicker: false,
                emojis: [
                    '😊',
                    '😂',
                    '😍',
                    '😢',
                    '😎',
                    '👍',
                    '❤️',
                    '🔥',
                    '🥰',
                    '😅',
                    '👏',
                    '😇',
                    '🎉',
                    '💯',
                    '🙏',
                    '🤔',
                ],
            };
        },

        methods: {
            sendMessage() {
                const trimmed = this.newMessage.trim();
                if (!trimmed) return;
                // Send the message logic here
                this.$emit('messagesent', this.user, this.$page.props.user, trimmed);
                this.newMessage = '';
                this.autoResize();
            },

            appendEmoji(emoji) {
                this.newMessage += emoji;
                this.$nextTick(() => {
                    this.autoResize();
                    this.focusTextarea();
                });
            },

            autoResize() {
                const el = this.$refs.textarea;
                el.style.height = 'auto';
                const maxHeight = parseInt(getComputedStyle(el).lineHeight) * 4; // max 4 lines
                el.style.height = Math.min(el.scrollHeight, maxHeight) + 'px';
            },

            focusTextarea() {
                this.$refs.textarea.focus();
            },
        },
    };
</script>
